import type { ReactNode } from 'react';

/**
 * A table column, so every table renders from one list and the owner's rule
 * (a column that is 0 / null / "—" on every row is hidden, and the note says
 * so - lib/visibleColumns.ts) can drop one without a colSpan going stale.
 * `get` is the RAW value the rule reads (the number, not "$0.00"); `cell` is
 * the rendering; `head` the <th> class; `foot` a footer cell where the table
 * has totals.
 */
export interface Col<T> {
  key: string;
  head?: string | undefined;
  fixed?: boolean | undefined;
  get: (r: T) => unknown;
  cell: (r: T) => ReactNode;
  cellClass?: string | ((r: T) => string) | undefined;
  title?: ((r: T) => string | undefined) | undefined;
  foot?: ReactNode | undefined;
  footClass?: string | undefined;
}

export function tdClass<T>(c: Col<T>, r: T): string | undefined {
  return typeof c.cellClass === 'function' ? c.cellClass(r) || undefined : c.cellClass;
}

/** Non-USD rows a USD figure leaves out because no rate exists yet - said
 * next to the figure, never silently and never counted at face value. */
export function Excluded({ n }: { n: number }) {
  if (!(n > 0)) return null;
  return (
    <span
      className="count"
      style={{ color: 'var(--loss)' }}
      title="Non-USD rows with no USD reference rate yet: excluded from this figure, never counted at face value. Rates refresh daily."
    >
      {' '}
      {n} excluded
    </span>
  );
}
